import React, { useState, useEffect } from 'react';
import { Currency, GetHospital } from '../Utils/Utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Patient from './PatientList';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

export default function AreaPatientList(props)
{
    useEffect(() => {
        //console.log(props.apdata);
    });

    const objareas = props.apdata;
    const areas = [];
    for(var a in objareas) {
        areas.push(objareas[a]);
     }
    areas.sort(function(a, b) {
        if (a.Tipo > b.Tipo) {
          return 1;
        } else if (a.Tipo < b.Tipo) {
          return -1;
        } else {
          return 0;
        }
      });
    var listAreas = areas.map((area, index) =>
        <AreaList active={props.active?'1':'0'} {...area} key={index}/>
    );

    return(
        <section className="p8">
            <div>
                <p>
                <span style={props.adeudo>0?{color:'#d32f2f'}:{color:'#348e34'}}>
                    <strong>{'Adeudo: '+Currency.format(props.adeudo)}</strong>&#8195;
                </span>
                <span hidden={props.capacidad === 0}>
                    <strong>{'Capacidad: '+props.capacidad+' Hab.'}</strong>&#8195;
                </span>
                <span style={props.porcentaje >= 100 ? {color:'red'}:{color:'green'}}  
                        hidden={props.capacidad === 0}>
                    <strong>{'Ocupado: %'+props.porcentaje}</strong>
                </span>
                </p>
            </div>
            <div>{listAreas}</div>
        </section>
        );

}

function AreaList(props)
{
    const [isopen, setIsopen] = useState(props.active);

    useEffect(() => {
        setIsopen(props.active);
    },[props.active]);

    const objpatients = props.Pacientes;
    const patients = [];
    for(var p in objpatients) {
        patients.push(objpatients[p]);
     }
    const listPatients = patients.map((patient,index) =>
        <Patient {...patient} key={index}/>
    );

    //const hosp = GetHospital();

    if (patients.length>0)
    {
        return(
            <Accordion activeKey={isopen} style={{marginBottom:'8px'}}>
                <Card border="primary">
                    <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => setIsopen(isopen==='1'?'0':'1')}>
                        <Row className="mr-0 ml-0">
                            <Col xs={12} sm={6} md={6} lg={4} xl={4}>
                                <span className={props.Tipo === 1 ?'blue':'orange'}><strong>{props.Area}</strong></span>
                                <span>&#8195;</span>
                                <span><strong>{props.Pacientes.length}</strong></span>
                                <span> Pacientes</span>
                                <span>&#8195;</span>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={4} xl={4}>
                                <span style={props.AdeudoArea>0?{color:'#d32f2f'}:{color:'#348e34'}}>
                                {'Adeudo Area: '+Currency.format(props.AdeudoArea)}</span>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                                <span hidden={props.Capacidad === 0 || props.Tipo === 3}>
                                    <span>Capacidad: </span>
                                    <span><strong>{props.Capacidad}</strong></span>
                                    <span> Habi. &#8195;</span>
                                    <span hidden={!props.addcount} style={props.Porcentaje >= 100 ? {color:'red'}:{color:'green'}}>
                                    Ocupado: <strong>{"%"+props.Porcentaje}</strong>
                                    </span>
                                </span>
                                <span className="alright hover_pointer">
                                    <FontAwesomeIcon className="fsp24 vac blue" icon={faAngleDown}/>
                                </span>
                            </Col>
                        </Row>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <div>
                        {listPatients}
                        </div>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
            );
    } else {
        return(<></>);
    }
}